import { Controller } from '@hotwired/stimulus';
import { trackInteraction } from '../lib/track_interaction';

export default class extends Controller {
    static values = { courseId: Number, lessonId: Number };

    clicked(event) {
        trackInteraction('lesson_attachment_clicked', {
            course_id: this.courseIdValue,
            lesson_id: this.lessonIdValue,
            attachment_id: Number(event.currentTarget.dataset.attachmentId)
        });
    }
}
